import { Suspense, lazy, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import "../src/pages/login/style.css";
import Layout from "./pages/global/Layout";
import { authCheck } from "./pages/login/redux/action";
import { AuthType } from "./pages/login/redux/type";
import GlobalLoader from "./components/GlobalLoader";

export function PrivateRoute() {
  const Login = lazy(() => import("./pages/login/LoginScreen"));
  const VerifyEmailScreen = lazy(() => import("./pages/login/VerifyEmailScreen"));
  const ResetPassword = lazy(() => import("./pages/login/ResetPassword"));

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth, shallowEqual);
  useEffect(() => {
    if (user != null) {
      dispatch(authCheck()).then((data) => {
        if (data?.type === "AUTH_CHEK_SUCCESS") {
          if (data?.payload?.status === false) {
            dispatch({ type: AuthType.LOG_OUT });
          }
        }
        if (data?.type === "AUTH_CHEK_FAIL") {
          dispatch({ type: AuthType.LOG_OUT });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return user && user != null && user !== undefined ? (
    <Layout />
  ) : (
    <Suspense fallback={<GlobalLoader />}>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/verify-email/:token" element={<VerifyEmailScreen />} />
        <Route exact path="/set-password/:token" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
}
